/*
 * Copyright (c) 2022. American Express Company
 */

// theirs
import React, { Component, ReactComponentElement } from 'react';

// ours
import { IconLinkViewModel } from 'src/types/view-models/icon-link.view.model';
import { TypographyVariants } from 'src/types/typography-variants.enum';

import { LinkColorVariants } from 'src/types/link-color-variants.enum';
import Typography from '../typography/Typography';
import Anchor from 'src/components/atomic/atoms/anchor/Anchor';
import './IconLink.scss';

export default class IconLink extends Component<IconLinkViewModel> {
    public override state = {
        filled: false
    };

    public override render(): ReactComponentElement<any> {
        const icon: JSX.Element = React.cloneElement(this.props.icon, {
            filled: this.state.filled,
            className: this.props.className
        });
        return (
            <Anchor
                href="#"
                onClick={() => {
                    void this.props.onClick();
                }}
                onMouseEnter={() => this.setState({ filled: true })}
                onMouseLeave={() => this.setState({ filled: false })}
                data-cy={this.props.id ? `IconLink-${this.props.id}` : null}
            >
                {this.props.text ? (
                    <Typography
                        variant={this.props.typographyVariant || TypographyVariants.BODY}
                        className={this.getTypographyClasses()}
                        key={this.props.typographyKey}
                    >
                        {icon}
                        {this.props.text}
                    </Typography>
                ) : (
                    icon
                )}
            </Anchor>
        );
    }

    private getTypographyClasses(): string {
        const classes: string[] = ['iconLinkText'];

        if (this.props.typographyClassName) {
            classes.push(this.props.typographyClassName);
        }

        if (this.props.linkColor === LinkColorVariants.ERROR) {
            classes.push('errorLink');
        } else if (this.props.linkColor === LinkColorVariants.WARNING) {
            classes.push('warningLink');
        } else {
            classes.push('link');
        }

        if (this.props.noUnderline) {
            classes.push('noUnderline');
        }

        return classes.join(' ');
    }
}
